(function(){
    angular
        .module('app')
        .directive('ngDatepicker', datepicker);

        datepicker.$inject = ['$timeout'];
        function datepicker($timeout){
            return {
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    element.datepicker({ 
                        format: 'yyyy-mm-dd',
                        todayHighlight: true,
                        autoclose: true,
                        weekStart: 1,
                        enableOnReadonly:false,
                    });
                });
            }
          }
      }
})();